module.exports = {"name":"Text (úzke stĺpce)","widget":{"type":"pure-html","initData":{"html":"<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem quaerat dolorum nobis sequi placeat.</p><p>Tenetur reiciendis doloremque possimus eius accusantium, incidunt laboriosam magni quam esse modi? Cum earum maiores eos.</p>"}}}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/content-col-small/content-col-small.json
// module id = 319
// module chunks = 0